import BrandAnalysisTable from "./ThirdPage/BrandAnalysisTable";
import BarChart from "./ThirdPage/BarChart";
import PieCard from './SecondPage/PieCard';
import SuspectedTable from "./SecondPage/SuspectedTable";
import TestPurchaseTable from './FourthPage/TestPurchaseTable';




import React, { useState, useEffect } from 'react';
import {
    Box,
    Flex,
    Heading,
    Image,
    Text,
    SimpleGrid,
    useColorModeValue
} from '@chakra-ui/react';
// import logo from '../../../../BA/assets/logo.png';
import './FirstPage/FirstPage.css';

const CombinedReportComponent = (props) => {
    const {
        brandName,
        topSuspectedBrands,
        topSuspectedSellers,
        topInfringingPlatforms,
        brandWise,
        platformWise,

        test
    } = props;


    const [name, setName] = useState("");
    const [timeline, setTimeline] = useState('');
    const textColor = useColorModeValue("secondaryGray.900", "white");

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const encodedDateFilter = searchParams.get('dateFilter');

        if (encodedDateFilter) {
            try {
                const decodedDateFilter = JSON.parse(decodeURIComponent(encodedDateFilter));

                if (decodedDateFilter) {
                    const { startDate, endDate } = decodedDateFilter;

                    // Convert strings to Date objects
                    const start = new Date(startDate);
                    const end = new Date(endDate);

                    if (!isNaN(start) && !isNaN(end)) {
                        // Check if the dates are valid
                        const options = { year: 'numeric', month: 'long' };
                        let startFormatted = new Intl.DateTimeFormat('en-US', options).format(start);
                        let endFormatted = new Intl.DateTimeFormat('en-US', options).format(end);
                        if (startFormatted === "August 2000") {
                            startFormatted = "";
                        }

                        setTimeline(`${startFormatted} - ${endFormatted}`);
                    } else {
                        console.error('Invalid Date objects:', start, end);
                    }
                }
            } catch (error) {
                console.error('Error parsing dateFilter:', error);
            }
        }

        if (brandName) {
            setName(brandName);
        }
    }, [brandName]);

    return (
         <div className="combined-report-component" style={{display: 'flex', flexDirection: 'column', minHeight: '297mm'}}>

            {/* Overview Section */}
            <div className="second-page" style={{minHeight: 'auto', height: 'auto', marginBottom: '80px', flex: 'none'}}>
                <Heading fontSize='24px' mb='30px'>
                    <Flex paddingBottom='10px' justify='space-between' align='center'>
                        <Text
                            color={textColor}
                            lineHeight='100%'
                            m='auto'
                            className="heading1"
                        >
                            OVERVIEW
                        </Text>
                    </Flex>
                </Heading>
                
                <Flex px='10px' paddingBottom='20px' justify='space-between' align='center'>
                    <Text
                        color={textColor}
                        lineHeight='100%'
                        m='auto'
                        className="heading2"
                    >
                        Top Suspected Brands
                    </Text>
                </Flex>
                <SimpleGrid columns="2" gap='10px' mb='60px'>
                    <SuspectedTable finalData={topSuspectedBrands} heading="Brands" />
                    <PieCard finalData={topSuspectedBrands}/>
                </SimpleGrid>
                
                <Flex px='10px' paddingBottom='20px' justify='space-between' align='center'>
                    <Text
                        color={textColor}
                        lineHeight='100%'
                        m='auto'
                        className="heading2"
                    >
                        Top Suspected Sellers
                    </Text>
                </Flex>
                <SimpleGrid columns='2' gap='10px' mb='60px'>
                    <SuspectedTable finalData={topSuspectedSellers} heading="Sellers" />
                    <PieCard finalData={topSuspectedSellers} />
                </SimpleGrid>
                
                <Flex px='10px' pb='20px' justify='center' align='center'>
                    <Text
                        color={textColor}
                        lineHeight='100%'
                        className="heading2"
                    >
                        Top Infringing Platforms
                    </Text>
                </Flex>
                <SimpleGrid columns="2" gap='10px' mb='60px'>
                    <SuspectedTable finalData={topInfringingPlatforms} heading="Platforms" />
                    <PieCard finalData={topInfringingPlatforms} />
                </SimpleGrid>
            </div>

            {/* Detail Analysis Section */}
            <div className="third-page" style={{minHeight: 'auto', height: 'auto', marginBottom: '80px', flex: 'none'}}>
                <Heading fontSize='24px' mb='30px'>
                    <Flex paddingBottom='10px' justify='space-between' align='center'>
                        <Text
                            color={textColor}
                            lineHeight='100%'
                            m='auto'
                            className="heading1"
                        >
                            DETAIL ANALYSIS
                        </Text>
                    </Flex>
                </Heading>
                
                <div className="brand-analysis-section" style={{minHeight: 'auto', height: 'auto', marginBottom: '60px'}}>
                    <Flex px='10px' paddingBottom='20px' justify='space-between' align='center'>
                        <Text
                            color={textColor}
                            lineHeight='100%'
                            m='auto'
                            className="heading2"
                        >
                            Brand-wise
                        </Text>
                    </Flex>
                    <div className="analysis-content" style={{minHeight: 'auto', height: 'auto'}}>
                        <SimpleGrid columns="2" gap='10px' mb='40px'>
                            <BrandAnalysisTable finalData={brandWise} heading="Brands" />
                            <BarChart finalData={brandWise} />
                        </SimpleGrid>
                    </div>
                </div>

                <div className="platform-analysis-section" style={{minHeight: 'auto', height: 'auto', marginBottom: '60px'}}>
                    <Flex px='10px' paddingBottom='20px' justify='space-between' align='center'>
                        <Text
                            color={textColor}
                            lineHeight='100%'
                            m='auto'
                            className="heading2"
                        >
                            Platform Analysis
                        </Text>
                    </Flex>
                    <div className="analysis-content" style={{minHeight: 'auto', height: 'auto'}}>
                        <SimpleGrid columns="2" gap='10px' mb='40px'>
                            <BrandAnalysisTable finalData={platformWise} heading="Platforms" />
                            <BarChart finalData={platformWise} />
                        </SimpleGrid>
                    </div>
                </div>
            </div>

            {/* Test Purchase Section */}
            {test &&
            <div className="fourth-page" style={{minHeight: '150vh',  marginBottom: '80px', flex: 'none'}}>
                <Heading mb='30px'>
                    <Flex paddingBottom='10px' justify='space-between' align='center'>
                        <Text
                            color={textColor}
                            lineHeight='100%'
                            m='auto'
                            className="heading1"
                        >
                            TEST PURCHASE
                        </Text>
                    </Flex>
                </Heading>
                
                <Flex px='10px' paddingBottom='40px' justify='space-between' align='center'>
                    <Text
                        color={textColor}
                        lineHeight='100%'
                        m='auto'
                        className="heading2"
                    >
                        Genuine v/s Counterfeit
                    </Text>
                </Flex>
                <Flex paddingInline={100} paddingBottom={40} justify="center" align="center">
                    <TestPurchaseTable finalData={test} heading="Brands" />
                </Flex>
                
                {/* <Flex px='10px' paddingBottom='40px' justify='space-between' align='center'>
                    <Text
                        color={textColor}
                        lineHeight='100%'
                        m='auto'
                        className="heading2"
                    >
                        Sellers
                    </Text>
                </Flex>
                <Flex paddingInline={100} justify="center" align="center">
                    <TestPurchaseTable finalData={test} heading="Sellers" />
                </Flex> */}
            </div>
            }
        </div>
    );
};

export default CombinedReportComponent;